import type { FilterValue } from '@/components/Table/types';

export function getDefaultEvidenceFiltersForMapping(
  mappingContent:
    | {
        name: string;
        selectedPmYear?: number;
        selectedPmYearFrom?: number;
        selectedPmYearTo?: number;
        selectedReferenceType?: 'PMID' | 'NCTID' | 'ALL';
      }
    | undefined,
): FilterValue[] | undefined {
  if (!mappingContent) return undefined;

  if (mappingContent.name === 'numPMIDsupportingAssociation') {
    const selectedType = mappingContent.selectedReferenceType ?? 'PMID';
    const base: FilterValue[] =
      selectedType === 'ALL'
        ? []
        : [{ name: 'reference_type', operator: 'eq', type: 'select', value: [selectedType] }];
    const yf = mappingContent.selectedPmYearFrom;
    const yt = mappingContent.selectedPmYearTo;
    const hasRange =
      yf != null &&
      yt != null &&
      Number.isFinite(Number(yf)) &&
      Number.isFinite(Number(yt)) &&
      Number(yf) <= Number(yt);
    if (hasRange) {
      const a = Math.trunc(Number(yf));
      const b = Math.trunc(Number(yt));
      base.push(
        {
          name: 'pmYear',
          operator: 'gte',
          type: 'number',
          integer: true,
          value: String(a),
        },
        {
          name: 'pmYear',
          operator: 'lte',
          type: 'number',
          integer: true,
          value: String(b),
        },
      );
    } else if (
      mappingContent.selectedPmYear != null &&
      Number.isFinite(Number(mappingContent.selectedPmYear))
    ) {
      const y = Number(mappingContent.selectedPmYear);
      base.push({
        name: 'pmYear',
        operator: 'eq',
        type: 'number',
        integer: true,
        value: String(y),
      });
    }
    return base;
  }

  if (mappingContent.name === 'numCTsSupportingAssociation' || mappingContent.name === 'numCTs') {
    return [{ name: 'reference_type', operator: 'eq', type: 'select', value: ['NCTID'] }];
  }

  return undefined;
}
